import { useState, useEffect } from 'react';
import { getImageDimensions } from '../../../../../../utilities/graphicUtilities';

// The proportions of the picture itself, which the size controls need before they can say how much
// of the frame it covers. The browser has the file in its cache by the time the panel asks, because
// the list item drew the very same URL as its thumbnail. Undefined until the answer arrives.
export default function useImageElementNaturalSize(imageUrl) {
    const [naturalSize, setNaturalSize] = useState(undefined);

    useEffect(() => {
        if (!imageUrl) {
            setNaturalSize(undefined);
            return;
        }

        // The user can swap the picture while the previous one is still being measured, and writing
        // the old answer over the new one would leave the controls describing the wrong image.
        let abandoned = false;

        getImageDimensions(imageUrl)
            .then((dimensions) => {
                if (!abandoned)
                    setNaturalSize(dimensions);
            })
            .catch(() => {
                if (!abandoned)
                    setNaturalSize(undefined);
            });

        return () => { abandoned = true; };
    }, [imageUrl]);

    return naturalSize;
}
